import {getEnglishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Оцініть статтю',
    message: 'Віддано голоси',
    votes: votes => `${getEnglishPlurals(["думка", "думки"], +votes)},`,
    score: 'рейтинг'
  },
  feedback: {
    label: 'Чи була ця стаття корисною?'
  }
};
